import { OPEN_CONFIRMATION, CLOSE_CONFIRMATION, UPDATE_DRAWER_NO } from "../constants";

export type DialogState = {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onClose: () => void;
  closable: boolean;
  closeButtonTitle: string;
  confirmButtonTitle: string;
  drawerNo: number;
};

export const initialState: DialogState = {
  isOpen: false,
  title: "",
  message: "",
  onConfirm: () => {},
  onClose: () => {},
  closable: true,
  closeButtonTitle: "close",
  confirmButtonTitle: "confirm",
  drawerNo: -1,
};

const dialogReducer = (state: DialogState = initialState, action) => {
  switch (action.type) {
    case OPEN_CONFIRMATION:
      return {
        ...state,
        isOpen: true,
        title: action.payload.title,
        message: action.payload.message,
        onConfirm: action.payload.onConfirm,
        onClose: action.payload.onClose,
        closable: action.payload.closable ?? initialState.closable,
        closeButtonTitle: action.payload.closeButtonTitle ?? initialState.closeButtonTitle,
        confirmButtonTitle: action.payload.confirmButtonTitle ?? initialState.confirmButtonTitle,
      };
    case CLOSE_CONFIRMATION:
      return {
        ...state,
        isOpen: false,
      };
    case UPDATE_DRAWER_NO:
      return {
        ...state,
        drawerNo: action.payload,
      };
    default:
      return state;
  }
};

export default dialogReducer;
